/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import axios from 'axios';
import lodash from 'lodash';
import kpiHelpers from '../../helpers/kpis';

// initial state
const state = {
  report: null,
  metricTemplate: {
    type: 'money',
    aggregateType: 'sum',
    higherIsBetter: 1,
  },
  metrics: [
    { name: 'Gross Revenue' },
    {
      name: 'Gross HA Rev % of Gross Rev',
      field: 'gross_ha_rev_per_gross_rev',
      type: 'percent',
      aggregateType: 'avg',
      higherIsBetter: 0,
    },
    { name: 'Net HA Revenue' },
    {
      name: 'HA Discounts Given',
      higherIsBetter: -1,
    },
    {
      name: 'Average Dollars Discounted',
      field: 'avg_dollars_discounted',
      aggregateType: 'avg',
      higherIsBetter: -1,
    },
    {
      name: 'HA $ Refunded',
      field: 'ha_money_refunded',
      higherIsBetter: -1,
    },
    {
      name: 'HA Cost of Goods',
      field: 'ha_cogs',
    },
    { name: 'HA Gross Profit' },
    {
      name: 'Gross Margin % of Net HA Revenue',
      field: 'gross_margin_per_net_ha_rev',
      type: 'percent',
      aggregateType: 'avg',
      higherIsBetter: 0,
    },
    {
      name: 'Marketing Spend',
      higherIsBetter: -1,
    },
    {
      name: 'Marketing Spend %',
      field: 'marketing_spend_per',
      type: 'percent',
      aggregateType: 'avg',
      higherIsBetter: -1,
    },
    {
      name: 'Payroll & Related % of Net Revenue',
      field: 'payroll_related_per_net_rev',
      type: 'percent',
      aggregateType: 'avg',
      higherIsBetter: -1,
    },
    {
      name: 'Other Operating Expenses',
      higherIsBetter: -1,
    },
    { name: 'Net Profit' },
    {
      name: 'Net Profit % of Net HA Revenue',
      field: 'net_profit_per_net_ha_rev',
      type: 'percent',
      aggregateType: 'avg',
      higherIsBetter: 0,
    },
    {
      name: '# of HAs Sold',
      field: 'number_ha_sold',
      type: 'unit',
    },
    {
      name: '# of HAs Refunded',
      field: 'number_ha_refunded',
      type: 'unit',
    },
    {
      name: 'Net HA Units',
      field: 'net_units_sold',
      type: 'unit',
    },
    {
      name: 'Unit Refund Rate %',
      field: 'unit_refund_rate',
      type: 'percent',
      aggregateType: 'avg',
      higherIsBetter: -1,
    },
    {
      name: 'Discount %',
      field: 'discount_per',
      type: 'percent',
      aggregateType: 'avg',
      higherIsBetter: -1,
    },
    {
      name: '# of Audiograms (92557)',
      field: 'number_audiograms',
      type: 'unit',
    },
    {
      name: '# of HAE Appointments',
      field: 'number_ha_appointments',
      type: 'unit',
    },
    {
      name: '# of Patients that Purchased',
      field: 'number_patients_purchased',
      type: 'unit',
    },
    {
      name: 'HAE Conversion Rate %',
      field: 'hae_conversion_rate',
      type: 'percent',
      aggregateType: 'avg',
    },
    {
      name: 'HAE to Audiogram Appt. Ratio',
      field: 'hae_to_audiogram_rate',
      type: 'percent',
      aggregateType: 'avg',
    },
    {
      name: 'Binaural Rate %',
      field: 'binaural_rate',
      type: 'percent',
      aggregateType: 'avg',
    },
    {
      name: 'Dollar Refund Rate %',
      field: 'dollar_refund_rate',
      type: 'percent',
      aggregateType: 'avg',
      higherIsBetter: -1,
    },
    {
      name: 'Average Patient Net Revenue',
      field: 'avg_patient_net_rev',
      aggregateType: 'avg',
    },
    {
      name: 'Gross Average Selling Price',
      field: 'avg_selling_price_pre_disc',
      aggregateType: 'avg',
    },
    {
      name: 'Net Average Selling Price',
      field: 'avg_selling_price_post_disc',
      aggregateType: 'avg',
    },
    {
      name: 'Margin per Unit',
      field: 'margin_per_unit',
      aggregateType: 'avg',
    },
    {
      name: '# of Providers',
      field: 'number_providers',
      type: 'unit',
      aggregateType: 'avg',
      higherIsBetter: 0,
    },
    {
      name: '# of Physicians',
      field: 'number_physicians',
      type: 'unit',
      aggregateType: 'avg',
      higherIsBetter: 0,
    },
    {
      name: 'Net Revenue Per Provider',
      field: 'net_rev_per_provider',
      aggregateType: 'avg',
    },
    {
      name: 'Net Revenue Per Physician',
      field: 'net_rev_per_physician',
      aggregateType: 'avg',
    },
    { name: 'Gross HA Revenue' },
    {
      name: 'Payroll & Related Expenses',
      higherIsBetter: -1,
    },
    {
      name: 'Audiograms Per Physician',
      field: 'num_audiograms_by_physician',
      type: 'unit',
      aggregateType: 'avg',
    },
    {
      name: 'Audiograms Per Audiologist',
      field: 'num_audiograms_by_audiologist',
      type: 'unit',
      aggregateType: 'avg',
    },
    {
      name: 'HA Opportunities By Audiologist',
      type: 'unit',
      aggregateType: 'avg',
    },
    {
      name: '% Audios Converted to Opportunity',
      field: 'percent_audios_converted_to_opportunity',
      type: 'percent',
      aggregateType: 'avg',
      precision: 0
    },
    {
      name: '# Audios to Generate Opportunity',
      field: 'num_audios_to_generate_opportunity',
      type: 'unit',
      aggregateType: 'avg',
      higherIsBetter: -1,
    },
    {
      name: '# Audios to Hearing Aid Purchase',
      field: 'num_audios_to_generate_purchase',
      type: 'unit',
      aggregateType: 'avg',
      higherIsBetter: -1,
    },
    {
      name: '# Opportunities (HAEs) to Generate Purchase',
      field: 'num_opportunities_to_generate_purchase',
      type: 'unit',
      aggregateType: 'avg',
      higherIsBetter: -1,
      precision: 1
    },
    {
      name: 'Hearing Aid Units Per Patient',
      type: 'unit',
      aggregateType: 'avg',
      precision: 1,
    },
    {
      name: '# HA Fittings by Audiologist',
      field: 'num_ha_fittings_by_audiologist',
      type: 'unit',
      aggregateType: 'avg',
    },
    {
      name: 'Net HA Units by Audiologist',
      type: 'unit',
      aggregateType: 'avg',
    },
    {
      name: 'Net HA Revenue by Audiologist',
      field: 'net_hearing_aid_revenue_by_audiologist',
      aggregateType: 'avg',
    },
    {
      name: 'Net HA Gross Margin by Audiologist',
      field: 'net_hearing_aid_gross_margin_by_audiologist',
      aggregateType: 'avg',
    },
    {
      name: 'Cost / Unit',
      field: 'cost_per_unit',
      aggregateType: 'avg',
    },
    {
      name: 'Margin / Patient',
      field: 'margin_per_patient',
      aggregateType: 'avg',
    },
    {
      name: 'COG %',
      field: 'cog_percent',
      type: 'percent',
      aggregateType: 'avg',
      higherIsBetter: -1,
      precision: 0,
    },
    {
      name: 'Audiologist to Physician Ratio',
      field: 'audiologist_to_physician_ratio',
      type: 'ratio',
      aggregateType: 'avg',
      higherIsBetter: 1
    },
  ],
  dashboardData: {
    prevYear: [],
    curYear: [],
    month: null,
    year: null,
    yearStart: null,
  },
  prevYear: [],
  curYear: [],
  month: null,
  year: null,
  years: [],
  yearsList: [],
  comments: [],
  benchmarks: [],
  yearStart: null,
  activeSection: 'performance',
  compMode: 'number',
  prevYearNull: null,
  monthAbbrevs: ['Target', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  metricsFinancialPerformanceFields: [
    'gross_revenue',
    'gross_ha_rev_per_gross_rev',
    'net_ha_revenue',
    'ha_discounts_given',
    'avg_dollars_discounted',
    'ha_money_refunded',
    'ha_cogs',
    'ha_gross_profit',
    'gross_margin_per_net_ha_rev',
    'marketing_spend',
    'marketing_spend_per',
    'payroll_related_expenses',
    'payroll_related_per_net_rev',
    'other_operating_expenses',
    'net_profit',
    'net_profit_per_net_ha_rev',
  ],
  metricsOperationalPerformanceFields: [
    'number_ha_sold',
    'number_ha_refunded',
    'net_units_sold',
    'unit_refund_rate',
    'discount_per',
    'number_audiograms',
    'number_ha_appointments',
    'number_patients_purchased',
    'hae_conversion_rate',
    'hae_to_audiogram_rate',
    'binaural_rate',
    'dollar_refund_rate',
    'avg_patient_net_rev',
    'avg_selling_price_pre_disc',
    'avg_selling_price_post_disc',
    'margin_per_unit',
  ],
  metricsPersonnelPerformanceFields: [
    'number_providers',
    'number_physicians',
    'net_rev_per_provider',
    'net_rev_per_physician',
  ],
  metricsHighLevelPerformanceFields: [
    'gross_revenue',
    'gross_ha_revenue',
    'ha_discounts_given',
    'ha_money_refunded',
    'net_ha_revenue',
    'ha_cogs',
    'ha_gross_profit',
    'marketing_spend',
    'payroll_related_expenses',
    'other_operating_expenses',
    'net_profit',
    'number_audiograms',
    'number_ha_appointments',
    'number_patients_purchased',
    'number_ha_sold',
    'number_ha_refunded',
    'number_providers',
    'number_physicians',
  ],
  metricsKeyIndicatorsPerformanceFields: [
    'gross_ha_rev_per_gross_rev',
    'gross_margin_per_net_ha_rev',
    'net_profit_per_net_ha_rev',
    'marketing_spend_per',
    'payroll_related_per_net_rev',
    'net_rev_per_provider',
    'net_rev_per_physician',
    'hae_conversion_rate',
    'hae_to_audiogram_rate',
    'binaural_rate',
    'avg_selling_price_pre_disc',
    'avg_dollars_discounted',
    'discount_per',
    'avg_selling_price_post_disc',
    'avg_patient_net_rev',
    'dollar_refund_rate',
    'unit_refund_rate',
    'margin_per_unit',
  ],
  metricsFuelUtilizationFields: [],
  ytdCustomCalculationFields: [
    'gross_ha_rev_per_gross_rev',
    'gross_margin_per_net_ha_rev',
    'net_profit_per_net_ha_rev',
    'marketing_spend_per',
    'payroll_related_per_net_rev',
    'net_rev_per_provider',
    'net_rev_per_physician',
    'hae_conversion_rate',
    'hae_to_audiogram_rate',
    'binaural_rate',
    'avg_selling_price_pre_disc',
    'avg_dollars_discounted',
    'discount_per',
    'avg_selling_price_post_disc',
    'avg_patient_net_rev',
    'dollar_refund_rate',
    'unit_refund_rate',
    'margin_per_unit',
    'num_audiograms_by_physician',
    'num_audiograms_by_audiologist',
    'ha_opportunities_by_audiologist',
    'percent_audios_converted_to_opportunity',
    'num_audios_to_generate_opportunity',
    'num_audios_to_generate_purchase',
    'num_opportunities_to_generate_purchase',
    'hearing_aid_units_per_patient',
    'net_ha_units_by_audiologist',
    'net_hearing_aid_revenue_by_audiologist',
    'net_hearing_aid_gross_margin_by_audiologist',
    'num_ha_fittings_by_audiologist',
    'cost_per_unit',
    'margin_per_patient',
    'cog_percent',
    'unit_refund_rate',
    'audiologist_to_physician_ratio',
  ],
  benchPrePurchaseMetrics: [
    'num_audiograms_by_physician',
    'num_audiograms_by_audiologist',
    'ha_opportunities_by_audiologist',
  ],
  benchConversionMetrics: [
    'percent_audios_converted_to_opportunity',
    'num_audios_to_generate_opportunity',
    'num_audios_to_generate_purchase',
    'num_opportunities_to_generate_purchase',
    'hae_conversion_rate',
    'hearing_aid_units_per_patient',
  ],
  benchConversionFittings: [
    'num_ha_fittings_by_audiologist',
  ],
  benchFinancialMetrics: [
    'net_ha_units_by_audiologist',
    'net_hearing_aid_revenue_by_audiologist',
    'net_hearing_aid_gross_margin_by_audiologist',
  ],
  benchKpiMetrics: [
    'avg_selling_price_post_disc',
    'avg_patient_net_rev',
    'cost_per_unit',
    'margin_per_unit',
    'margin_per_patient',
    'cog_percent',
    'gross_margin_per_net_ha_rev',
    'binaural_rate',
    'unit_refund_rate',
    'audiologist_to_physician_ratio',
  ],
  reportTotals: {
    curYear: {},
    prevYear: {},
    target: {},
  },
  loaders: {
    dashboardData: false,
    kpiData: false,
    comments: false,
    benchmarks: false,
  },
  initializers: {
    years: false,
    kpiData: false,
    dashboardData: false,
  },
};

// getters
const getters = {
  cancelToken: (state, getters, rootState) => rootState.main.cancelToken,
  member_id: (state, getters, rootState) => rootState.main.member_id,
  compMode: (state) => state.compMode,
  loaders: (state) => state.loaders,
  initializers: (state) => state.initializers,
  metrics: (state) => lodash.map(state.metrics, (metric) => {
    return {
      ...state.metricTemplate,
      field: lodash.snakeCase(metric.name),
      ...metric,
    };
  }),
  month: (state) => state.month,
  year: (state) => state.year,
  years: (state) => state.years,
  yearsList: (state) => lodash.map(state.years, (year) => ({
    value: year,
    label: !state.yearStart || state.yearStart === 1 ? year : `${year}/${parseInt(year.toString().substring(2)) + 1}`,
  })),
  yearStart: (state) => state.yearStart,
  report: (state) => state.report,
  prevYear: (state) => state.report ? (state.report.prevYear ? state.report.prevYear : state.report.curYear) : null,
  curYear: (state) => state.report ? state.report.curYear : null,
  curMonthOffset: (state) => (((parseInt(state.month, 10) + 11) - (state.yearStart - 1)) % 12),
  curMonth: (state, getters) => state.report ? getters.curYear[getters.curMonthOffset] : null,
  prevYearMonth: (state, getters) => state.report ? getters.prevYear[getters.curMonthOffset] : null,
  target: (state) => state.report.target,
  kpi_id: (state, getters) => getters.month ? getters.curMonth.audiology_kpi_id : null,
  comments: (state) => state.comments,
  benchmarks: (state) => state.benchmarks,
  dashboardData: (state) => state.dashboardData,
  fiscalYear: (state) => ([1, 12]).includes(state.yearStart),
  yearPrior: (state) => state.yearPrior,
  prevYearNull: (state, getters) => {
    if (!state.report) {
      return true;
    }
    if (lodash.findIndex(state.years, (year) => parseInt(year) === parseInt(state.year)) === (state.years.length - 1)) {
      return true;
    }
    if (getters.prevYear.length < 11) {
      return true;
    }
    return false;
    // state.report ? lodash.findIndex(state.years, (year) => parseInt(year) === parseInt(state.year)) === state.years.length - 1 || state.prevYear.length < 11 : true
  },
  yearCurrent: (state) => state.yearCurrent,
  latestMonth: (state) => (state.curYear ? state.curYear[state.curYear.length - 1].month : null),
  activeSection: (state) => state.activeSection,
  monthNames: (state) => lodash.map(state.monthNames, (monthName, index, collection) => (index === 0 || state.yearStart === 1) ? monthName : collection[((index + (state.yearStart - 2)) % 12) + 1]),
  monthAbbrevs: (state) => lodash.map(state.monthAbbrevs, (monthAbbrev, index, collection) => (index === 0 || state.yearStart === 1) ? monthAbbrev : collection[((index + (state.yearStart - 2)) % 12) + 1]),
  ytdCustomCalculationFields: (state) => state.ytdCustomCalculationFields,
  globalLoading: (state, getters, rootState) => rootState.main.globalLoading,
  hasData: (state) => !!state.year,
  metricsFinancialPerformance: (state, getters) => lodash.filter(getters.metrics, (metric) => state.metricsFinancialPerformanceFields.includes(metric.field)),
  metricsOperationalPerformance: (state, getters) => lodash.filter(getters.metrics, (metric) => state.metricsOperationalPerformanceFields.includes(metric.field)),
  metricsPersonnelPerformance: (state, getters) => lodash.filter(getters.metrics, (metric) => state.metricsPersonnelPerformanceFields.includes(metric.field)),
  // metricsHighLevelPerformance: (state, getters) => lodash.filter(getters.metrics, (metric) => state.metricsHighLevelPerformanceFields.includes(metric.field)),
  metricsHighLevelPerformance: (state, getters) => lodash.map(state.metricsHighLevelPerformanceFields, (field) => lodash.find(getters.metrics, (metric) => metric.field === field)),
  // metricsKeyIndicatorsPerformance: (state, getters) => lodash.filter(getters.metrics, (metric) => state.metricsKeyIndicatorsPerformanceFields.includes(metric.field)),
  metricsKeyIndicatorsPerformance: (state, getters) => lodash.map(state.metricsKeyIndicatorsPerformanceFields, (field) => lodash.find(getters.metrics, (metric) => metric.field === field)),
  metricsFuelUtilization: (state, getters) => lodash.filter(getters.metrics, (metric) => state.metricsFuelUtilizationFields.includes(metric.field)),
  monthsInReport: (state, getters) => {
    return lodash.reduce(getters.curYear, (monthsWithKPIData, month) => {
      const index = parseInt(month.month, 10);
      const monthName = state.monthNames[parseInt(month.month, 10)-1];

      // index = ((parseInt(month.month, 10) + 11) - (state.yearStart - 1)) % 12;
      //console.log(index, monthName);

      monthsWithKPIData.push({
        value: index,
        label: monthName,
      });
      return monthsWithKPIData;
    }, []);
  },
  benchPrePurchaseMetrics: (state, getters) => {
    return lodash.map(state.benchPrePurchaseMetrics, (bench) => {
      return lodash.find(getters.metrics, (metric) => metric.field === bench);
    });
  },
  benchConversionMetrics: (state, getters) => {
    return lodash.map(state.benchConversionMetrics, (bench) => {
      return lodash.find(getters.metrics, (metric) => metric.field === bench);
    });
  },
  benchConversionFittingMetrics: (state, getters) => {
    return lodash.map(state.benchConversionFittings, (bench) => {
      return lodash.find(getters.metrics, (metric) => metric.field === bench);
    });
  },
  benchFinancialMetrics: (state, getters) => {
    return lodash.map(state.benchFinancialMetrics, (bench) => {
      return lodash.find(getters.metrics, (metric) => metric.field === bench);
    });
  },
  benchKpiMetrics: (state, getters) => {
    return lodash.map(state.benchKpiMetrics, (bench) => {
      return lodash.find(getters.metrics, (metric) => metric.field === bench);
    });
  },
};

// actions
const actions = {
  /**
   * Loads Dashboard Audiology KPIs
   */
  getAudiologyKpisCardData({ commit }) {
    commit('TOGGLE_LOADING', { key: 'dashboardData', value: true });
    axios.get('/api/audiology/kpis/getAudiologyKpis/')
      .then(({ data }) => {
        commit('SET_PROPERTY', { key: 'dashboardData', value: data });
        commit('TOGGLE_LOADING', { key: 'dashboardData', value: false });
        commit('TOGGLE_INITIALIZED', { key: 'dashboardData', value: true });
      });
  },
  getAudiologyKpisYears({ commit }) {
    axios.get('/api/audiology/kpis/getAudiologyKpiYears')
      .then(({ data }) => {
        commit('SET_PROPERTY', { key: 'years', value: data });
        commit('SET_PROPERTY', { key: 'year', value: data[0] });
        commit('TOGGLE_INITIALIZED', { key: 'years', value: true });
      });
  },
  getReport({ commit, dispatch, state, getters }) {
    dispatch('main/setProperty', { key: 'globalLoading', value: true }, { root: true });
    return axios.get(`/api/member/${getters.member_id}/info/audiologyKpis/?year=${state.year}`)
      .then((response) => {
        if (response !== undefined && response !== -1) {
          let kpiUtility = new kpiHelpers();
          let report = kpiUtility.fillInEmptyMonths(response.data);

          // Save response
          commit('SET_PROPERTY', { key: 'report', value: report });
          commit('SET_PROPERTY', { key: 'month', value: response.data.curYear ? response.data.curYear.length : 12 });
          commit('SET_PROPERTY', { key: 'yearStart', value: response.data.yearStart ? response.data.yearStart : 1 });
          commit('TOGGLE_INITIALIZED', { key: 'kpiData', value: true });
          dispatch('main/setProperty', { key: 'globalLoading', value: false }, { root: true });
        }
      });
  },
  getComments({ commit, getters }) {
    commit('TOGGLE_LOADING', { key: 'comments', value: true });
    return axios.get(`/api/member/${getters.member_id}/info/audiologyKpisComments/?audiologyKpiId=${getters.kpi_id}`)
      .then((response) => {
        commit('SET_PROPERTY', { key: 'comments', value: response.data });
        commit('TOGGLE_LOADING', { key: 'comments', value: true });
      });
  },

  getBenchmarks({ commit, getters }) {
    commit('TOGGLE_LOADING', { key: 'benchmarks', value: true });
    return axios.get(`/api/member/${getters.member_id}/info/audiologyKpisBenchmarks/?business_id=${getters.member_id}`)
      .then(({ data }) => {
        commit('SET_PROPERTY', { key: 'benchmarks', value: data });
        commit('TOGGLE_LOADING', { key: 'benchmarks', value: true });
      });
  },

  async cancelAjax({ dispatch }) {
    await dispatch('main/cancelAjax', { root: true });
    return;
  },
  setProperty({ commit }, payload) {
    commit('SET_PROPERTY', payload);
  },
};

// mutations
const mutations = {
  SET_PROPERTY(state, payload) {
    state[payload.key] = payload.value;
  },
  TOGGLE_LOADING(state, payload) {
    state.loaders[payload.key] = payload.value;
  },
  TOGGLE_INITIALIZED(state, payload) {
    state.initializers[payload.key] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
